var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "paperclip"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M21.1537 10.8995L12.1381 19.9151C10.0878 21.9653 6.76372 21.9653 4.71347 19.9151C2.66322 17.8648 2.66322 14.5407 4.71347 12.4904L13.7291 3.47483C15.0959 2.108 17.312 2.108 18.6788 3.47483C20.0457 4.84167 20.0457 7.05775 18.6788 8.42458L10.0168 17.0866C9.33335 17.7701 8.22531 17.7701 7.5419 17.0866C6.85848 16.4032 6.85848 15.2952 7.5419 14.6118L15.1433 7.01037",
    stroke: "#2948A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.9c7dbbc0353743f7c43b6cb777f4424a.svg";
export { ForwardRef as ReactComponent };